import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { strings } from 'APP_ROOT/localization';
import eventMediaImagePlay from 'APP_ROOT/components/pages/dashboard/EventMedia/images/play-w64.svg';
import { EVENT_MEDIA_REQUEST_TYPE } from  'APP_ROOT/components/pages/dashboard/EventMedia/eventMediaConstants';

class EventItemMediaIcon extends React.PureComponent {

    eventHasShortOrShortPreview = () => { // DEPRECATED_VIDEO_PREVIEW_REQUEST

        if (!this.props.event) {
            return false;
        }

        if (!this.props.mediaList ) {
            console.warn("History EventItemMediaIcon eventHasShortOrShortPreview invalid media array property for event.  Returning false.", this.props.event);
            return false;
        }

        return this.props.mediaList.find(media => {

            if (media && media.get("type") === "MEDIA_PREVIEW_VIDEO") {
                return true;
            }
            if (media && media.get("type") === "MEDIA_SHORT") {
                if (media.get("availableOnRaven") === true) {
                    return true;
                }
            }
            return false;
        });
    }

    eventHasVideoAvailable = () => {

        if (!this.props.event) {
            return false;
        }

        let eventHasVideoAvailable = this.eventHasShortOrShortPreview();
        const eventVideoAvailable = this.props.event.get("videoAvailable");
        if (!eventVideoAvailable) {
            console.warn("EventItemMediaIcon eventHasVideoAvailable with event missing videoAvailable property");
            return eventHasVideoAvailable;
        }
        if (eventVideoAvailable.get("road") || eventVideoAvailable.get("cabin") ) {
            eventHasVideoAvailable = true;
        }
        return eventHasVideoAvailable;
    }

    eventHasCloudVideoClip = () => {

        if (!this.props.event) {
            return false;
        }
        const videoClipSource = this.props.mediaList.find(media => {
            if (media && media.get("type") === "MEDIA_PREVIEW_VIDEO") {
                return true;
            }
            if (media && media.get("type") === "MEDIA_STREAMING_ARCHIVE") {
                return true;
            }
        });
        return videoClipSource ? true : false;
    }

    render() {

        var iconForEventHasVideo = null;
        if (this.props.mediaRequestType === EVENT_MEDIA_REQUEST_TYPE.USER_MEDIA_REQUEST) {
            if (this.eventHasVideoAvailable()) {
                let className = "media-badge";
                let title = strings.title_media_video_clip_available_on_raven;
                if (this.eventHasCloudVideoClip()) {
                    className = className + " video-clip-uploaded";
                    title = strings.title_media_has_video_clip;
                }
                iconForEventHasVideo = (<img alt='Play' src={eventMediaImagePlay} className={className} title={title}/>);
            }
        } else if (this.props.mediaRequestType === EVENT_MEDIA_REQUEST_TYPE.VIDEO_PREVIEW_REQUEST) { // DEPRECATED_VIDEO_PREVIEW_REQUEST
            if (this.eventHasShortOrShortPreview()) { // DEPRECATED_VIDEO_PREVIEW_REQUEST
                iconForEventHasVideo = (<img alt='Play' src={eventMediaImagePlay} className="media-badge" />);
            }
        }

        return (
            <React.Fragment>
                {iconForEventHasVideo}
            </React.Fragment>
        );
    }
}

const getMediaForEvent = (state, ravenUuid, event) => {
    return event.get('mediaIds').toSeq()
        .map(mediaId => state.data.media.mediaMap.getIn([ravenUuid, mediaId]))
        .filter(m => m); // filter out undefined/null
}

const getEvent = (state, props) => {
    return state.data.events.eventMap.getIn([props.ravenUuid, props.eventId]);
};

const mapStateToProps = (state, ownProps) => { // get most up-to-date event object from redux store
    const event = getEvent(state, ownProps);
    const mediaList = getMediaForEvent(state, ownProps.ravenUuid, event)
    return {
        event: event,
        mediaList: mediaList
    }
}

export default connect(mapStateToProps)(EventItemMediaIcon);

EventItemMediaIcon.propTypes = {
    ravenUuid: PropTypes.string.isRequired,
    eventId: PropTypes.string.isRequired,
    mediaRequestType: PropTypes.string.isRequired
};